/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { Loader } from '@ui/atoms/Loader';
import { Popup } from '@ui/molecules/Popup';
import { translate } from '@utils/i18n';
import './WidgetFilterMenuStyles.scss';
/**
 * WidgetFilterMenu
 *
 * Compact filter tray for dashboard widget headers. Renders a `fa-light fa-filter`
 * icon button that opens a Quimby Popup listing the provided filter controls as
 * children. The popup's open/close state is managed locally; the parent owns only
 * the controlled state of the filter controls themselves (value / onChange).
 *
 * Structure:
 *   <WidgetFilterMenu title="Filters">
 *     <DateRangeFilter ... />
 *   </WidgetFilterMenu>
 *
 * @since 2026-07-31
 */
export function WidgetFilterMenu({ children, title, triggerTitle, loading = false }) {
    const [open, setOpen] = useState(false);
    const [anchor, setAnchor] = useState(null);
    const loadingLabel = translate('loading', { namespace: 'generic' });
    const buttonLabel = loading ? loadingLabel : triggerTitle !== null && triggerTitle !== void 0 ? triggerTitle : title;
    const expanded = open && !loading;
    // Close the tray when a soft refetch starts so loading → idle does not reopen it.
    useEffect(() => {
        if (loading)
            setOpen(false);
    }, [loading]);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { ref: setAnchor, type: "button", className: "qmb-control--icon qmb-widget-filter-menu__trigger", "aria-expanded": expanded, "aria-haspopup": "dialog", "aria-label": buttonLabel, title: buttonLabel, disabled: loading, onClick: () => {
                if (loading)
                    return;
                setOpen((prev) => !prev);
            } }, loading ? (React.createElement(Loader, { size: "16", className: "qmb-widget-filter-menu__loader", "data-testid": "service-widget-spinner" })) : (React.createElement("i", { className: "fa-light fa-filter", "aria-hidden": "true" }))),
        React.createElement(Popup, { anchor: anchor, show: expanded, onClose: () => setOpen(false), position: "bottom-right" },
            React.createElement(Popup.Section, null,
                React.createElement(Popup.Title, null, title),
                React.createElement("div", { className: "qmb-widget-filter-menu__filters" }, children)))));
}
